<mat-card
  class="group-card"
  [style.--containerWidth]="containerWidth() + 'px'"
  [style.--containerLeft]="containerLeft() + 'px'"
>
  <mat-card-content class="group-content">
    @if (expanded()) {
      <mat-icon class="group-arrow-icon" (click)="collapse()">keyboard_arrow_up</mat-icon>
    } @else {
      <mat-icon class="group-arrow-icon" (click)="expand()">keyboard_arrow_down</mat-icon>
    }
    <mat-icon class="group-folder-icon">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1976d2">
        <path
          d="M480-400 40-640l440-240 440 240-440 240Zm0 160L63-467l84-46 333 182 333-182 84 46-417 227Zm0 160L63-307l84-46 333 182 333-182 84 46L480-80Zm0-411 273-149-273-149-273 149 273 149Zm0-149Z"
        />
      </svg>
    </mat-icon>
    <div class="group-name">
      {{ groupName }}
    </div>

    <div class="group-icons">
      @if (groupNotes?.length > 0) {
        <mat-icon class="group-comment-icon" (click)="openPopover()" [glxyPopover]="popover">comment</mat-icon>
      }
      <glxy-popover #popover [(isOpen)]="isOpen" [closeOnBackdropClick]="true" [maxHeight]="'320px'">
        <glxy-popover-title>{{ 'AUTOMATIONS.EDITOR.NOTE_POPOVER.TITLE' | translate }}</glxy-popover-title>
        {{ groupNotes }}
        <glxy-popover-actions>
          <button mat-flat-button color="primary" (click)="editDetails()">
            {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
          </button>
        </glxy-popover-actions>
      </glxy-popover>
      <mat-icon class="group-kebab-icon" [matMenuTriggerFor]="kebabMenu">more_vert</mat-icon>

      <mat-menu #kebabMenu="matMenu">
        <button mat-menu-item (click)="editDetails()" data-action="node-edit-group-clicked">
          {{ 'AUTOMATIONS.GROUPING.EDIT_GROUP_DETAILS' | translate }}
        </button>
        <button mat-menu-item (click)="ungroup()" data-action="group-ungroup-clicked">
          {{ 'AUTOMATIONS.GROUPING.UNGROUP_ALL' | translate }}
        </button>
        <button mat-menu-item (click)="saveAsActionSet()">
          {{ 'AUTOMATIONS.SNIPPET.SAVE_AS_ACTION_SET' | translate }}
        </button>
        <button mat-menu-item (click)="deleteGroupClicked(groupId)">
          {{ 'AUTOMATIONS.GROUPING.DELETE_GROUP' | translate }}
        </button>
      </mat-menu>
    </div>
  </mat-card-content>
</mat-card>
<div
  class="group-container"
  [ngClass]="{ 'slow-expand': newlyExpanded() }"
  [style.--containerHeight]="containerHeight() + 'px'"
  [style.--containerWidth]="containerWidth() + 'px'"
  [style.--containerLeft]="containerLeft() + 'px'"
></div>
